import React from 'react'

import {
  SVGArrow,
  SVGMore,
  SVGShare,
  SVGShareField,
  SVGExit,
  SVGEdit,
  SVGTrashSmall,
  SVGBasketIconBlue,
  SVGOkoslista,
  SVGListShareAdd,
  SVGListShareAdded
} from "Components/SVGCollection";

import cn from 'classnames'
import cg from 'Scss/app.scss'
import cl from '../../ProfileNavListItem/ProfileNavListItem.scss'
import csl from '../ShoppingList.scss'
import DropdownMenu, {DropdownMenuButtonConfig} from "./DropdownMenu";
import {isListOwner} from "Utils/helpers/shoppingListHelpers";
import { ListType } from 'Utils/api/ListClient';

type PropType = {
  list: ShoppingList.IShoppingList
  allLists: ShoppingList.IShoppingList[]
  userId: string
  onClick?: (list: ShoppingList.IShoppingList) => void
  onRenameClick?: (list: ShoppingList.IShoppingList) => void
  onDeleteListClick?: (list: ShoppingList.IShoppingList) => void
  onLeaveListClick?: (list: ShoppingList.IShoppingList) => void
  onSharingClick?: (list: ShoppingList.IShoppingList) => void
  onAddToCartClick?: (list: ShoppingList.IShoppingList) => void
}

export default class ListItem extends React.Component<PropType> {
  dropdownRef: DropdownMenu | null = null

  onRenameList = () => {
    this.dropdownRef!.hide()
    this.props.onRenameClick && this.props.onRenameClick(this.props.list)
  }
  onRemoveList = () => {
    this.dropdownRef!.hide()
    this.props.onDeleteListClick && this.props.onDeleteListClick(this.props.list)
  }
  onLeaveList = () => {
    this.dropdownRef!.hide()
    this.props.onLeaveListClick && this.props.onLeaveListClick(this.props.list)
  }
  onAddToCart = () => {
    this.dropdownRef!.hide()
    this.props.onAddToCartClick && this.props.onAddToCartClick(this.props.list)
  }
  onClick = () => {
    this.props.onClick && this.props.onClick(this.props.list)
  }

  onSharingClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    e.preventDefault()
    this.props.onSharingClick && this.props.onSharingClick(this.props.list)
  }

  render() {
    // Possible actions
    // + Rename
    // Delete
    // Leave
    // Add to cart
    const actionsAvailable: DropdownMenuButtonConfig[] = []
    const allSmartlistCount = this.props.allLists.filter(list => list.type === ListType.SmartList).length

    if (isListOwner(this.props.userId, this.props.list)) {
      actionsAvailable.push({
        title: 'Átnevezés',
        icon: <SVGEdit width={32} height={32} />,
        callback: this.onRenameList
      })
      if ((this.props.list.type === ListType.SmartList && allSmartlistCount > 1) || (this.props.list.type === ListType.ShoppingList)) {
        actionsAvailable.push({
          title: 'Lista törlése',
          icon: <SVGTrashSmall width={32} height={28} />,
          callback: this.onRemoveList
        })
      }
    } else {
      actionsAvailable.push({
        title: 'Lista elhagyása',
        icon: <SVGTrashSmall width={32} height={28} />,
        callback: this.onLeaveList
      })
    }
    if (this.props.list.products.length > 0) {
      actionsAvailable.push({
        title: 'Kosárba rakás',
        icon: <SVGBasketIconBlue width={32} height={28} />,
        callback: this.onAddToCart
      })
    }

    return (
      <div className={cn(cl.profileNav__listItem, csl.profileNav__listItem)} onClick={this.onClick}>
        <div className={cn(cg.gridX, cg.alignMiddle, cl.listItem__gridX)}>
          {this.props.list.type === ListType.SmartList && (
            <div className={cn(cg.cell, cg.shrink, cl.cell, cl.shrink, cl.smartListIcon)}>
              <SVGOkoslista width={24} height={24} title={'A listát az Okoslista alkalmazásodban is megtalálod'}/> 
            </div>
          )}
          <div className={cn(cg.cell, cg.auto, cl.cell, cl.auto)}>
            <a onClick={this.onClick} className={cl.listItem__link}>
              {this.props.list.name}
            </a>
          </div>


          <div className={cn(cg.cell, cg.shrink, cl.cell, cl.shrink)}>
            {/* TODO: When opened: setHeight() or position: fixed? */}
            <DropdownMenu ref={(ref) => { this.dropdownRef = ref }} align="right" buttonConfig={actionsAvailable}>
              <SVGMore width={24} height={24} />
            </DropdownMenu>
          </div>
          <div className={cn(cg.cell, cg.shrink, cl.cell, cl.shrink)} >
            <span aria-hidden={true} title="Megosztás" className={cn(cl.exit)}>
              <a onClick={this.onSharingClick}>
                {this.props.list.users.length > 1 ? <SVGListShareAdded width={25} height={20}/> : <SVGListShareAdd width={25} height={20}/>}
              </a>
            </span>
          </div>

          <div className={cn(cg.cell, cg.shrink, cl.cell, cl.shrink, cl.listItem__badge)} style={this.props.list.products.length === 0 ? {opacity: 0.4} : {}} >
            {this.props.list.products.length}
          </div>

          <div className={cn(cg.cell, cg.shrink, cl.cell, cl.shrink)} style={this.props.list.products.length === 0 ? {opacity: 0.6} : {}}>
            <a onClick={this.onClick} className={cn(cl.listItem__link, cl.listItem__linkIsBlock)}>
              <span aria-hidden={true}>
                <SVGArrow width={24} height={24} />
              </span>
            </a>
          </div>

        </div>
      </div>
    )
  }
}